import { createService } from '@bonanza-social/toolkit/api';
import { UserBalancesSchema, CoinBalanceSchema } from './WalletService.schemas';

export default createService(
  {
    getCashBalance: {
      method: 'GET',
      url: '/balances',
      responseSchema: UserBalancesSchema,
    },
    getCoinBalance: {
      method: 'GET',
      url: '/coinbalance',
      responseSchema: CoinBalanceSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
